import Request from "@/libraries/request.js";
import Const from "@/const/const.js";

export default {
  BaseURL: "/order",
  async get(url = null) {
    const ordersReply = await Request.getAsync(url);
    let orders = [];
    if (ordersReply.data.status) {
      orders = ordersReply.data.data;
    }
    return orders;
  },
  async get_order(ordId = null) {
    const url = (ordId != null) ? this.BaseURL + "/" + ordId : this.BaseURL;
    const data = await this.get(url);
    return data;
  },
  async get_order_by_date_range(startDate, endDate) {
    const url = this.BaseURL + "/?startDate="+startDate+"&endDate="+endDate;
    const data = await this.get(url);
    return data;
  },
  async get_order_by_customer(cus_id, dateStart, dateEnd, type) {
    const url = this.BaseURL + "/?cus_id="+cus_id+"&startDate="+dateStart+"&endDate="+dateEnd+"&type="+type;
    const data = await this.get(url);
    return data;
  },
  async get_order_report(cus_id, dateStart, dateEnd, payment_status) {
    const url = this.BaseURL + "/?cus_id="+cus_id+"&startDate="+dateStart+"&endDate="+dateEnd+"&payment_status="+payment_status;
    const data = await this.get(url);
    return data;
  }
};




// WEBPACK FOOTER //
// ./src/model/order_model.js